import profileTypes from './user.types';

export const initialState = {
  profile: {},
  users: {}
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case profileTypes.SET_PROFILE:
      return {
        ...state,
        profile: action.payload
      };

    case profileTypes.SET_ALL_USER:
      return {
        ...state,
        users: action.payload
      };
    default:
      return state;
  }
};

export default profileReducer;
